/**
 * What has to be trusted, and what does not.
 *
 * The two bands here answer one question between them — *what am I handing this
 * thing, and what happens when part of it fails* — which is the question that
 * actually decides a purchase in this category and the one a feature list never
 * reaches. They were the last two sections of the old page, where a reader had
 * to get through seven bands of capability to find them.
 *
 * The installation band stays on this page rather than moving to a page of its
 * own. What it really says is *this runs on your machines and here is the
 * surface that implies*, including the gaps it is honest about; that is a
 * security fact before it is a getting-started one.
 */
import { Security, Install } from '../sections/Sections'
import { PageHeader } from '../sections/PageHeader'
import { Closing } from '../sections/Closing'

export function SecurityPage() {
  return (
    <>
      <PageHeader
        eyebrow="securityPage.eyebrow"
        title="securityPage.title"
        sub="securityPage.sub"
        toc={['security', 'install']}
      />
      <Security index={1} />
      <Install index={2} />
      <Closing />
    </>
  )
}
